"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headings = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const slugify_1 = __importDefault(require("slugify"));
const react_children_utilities_1 = __importDefault(require("react-children-utilities"));
const useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));
const TopBar_1 = require("../material-ui/TopBar");
const Typography_1 = require("../material-ui/Typography");
const Heading = (tag) => {
    const WrappedHeading = ({ id, children, ...props }) => {
        const theme = useTheme_1.default();
        const text = react_children_utilities_1.default.onlyText(children);
        id = id || slugify_1.default(text, { lower: true });
        const Heading = Typography_1.headings[tag];
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { id: id, style: { position: "relative", top: -1 * TopBar_1.topBarHeight(theme) - theme.spacing(2) } }),
            react_1.default.createElement(Heading, Object.assign({ "data-et": true, "data-et-id": id }, props), children)));
    };
    WrappedHeading.propTypes = {
        id: prop_types_1.default.string,
        children: prop_types_1.default.node.isRequired,
    };
    return WrappedHeading;
};
exports.headings = {
    h1: Heading("h1"),
    h2: Heading("h2"),
    h3: Heading("h3"),
    h4: Heading("h4"),
    h5: Heading("h5"),
    h6: Heading("h6"),
};
//# sourceMappingURL=Headings.js.map